import React from "react";
import {
  SEO,
  MarkdownContent,
  DynamicForm,
  InternalLink,
  OutboundLink,
} from "@bluefin/components";
import { Grid, Segment, Checkbox } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";

export default class ServiceConsultationPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      nfnjfmfpnjgkfnfplphpccldbinhgoninfnj,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.bellamiacademie.com/service-consultation/"}
        />
        <Grid className={"custom-page-grid"} style={{}} stackable={true}>
          <Grid.Row className={""} style={{ padding: 0 }} textAlign={"center"}>
            <Grid.Column
              className={""}
              style={{ padding: 16 }}
              width={10}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "a208f1d8-c068-42e2-a4cf-8dba72f26485",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className={""} style={{ padding: 16 }} columns={0} />
          <Grid.Row className={""} style={{ padding: 0 }} textAlign={"center"}>
            <Grid.Column
              className={""}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <DynamicForm
                  className={""}
                  style={{}}
                  businessId={1399}
                  businessInfoId={6579}
                  websiteId={7642}
                  locationId={1470}
                  componentConfigurationId={43800}
                  header={nfnjfmfpnjgkfnfplphpccldbinhgoninfnj.data.header}
                  fields={
                    nfnjfmfpnjgkfnfplphpccldbinhgoninfnj.data.dynamicFormFields
                  }
                  consentSettings={
                    nfnjfmfpnjgkfnfplphpccldbinhgoninfnj.data.consentSettings
                  }
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"xzefgdlzhwjxlqnc"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"lgijztncfmxgsniq"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__2d4abdd2-0305-44a3-9b4d-7bcc5fdca7a4"}
                >
                  <div className={"custom-tos-container"}>
                    <div>
                      <Checkbox
                        label={
                          "I consent to receive sms notifications, alerts from BellaMi Academie. Message frequency varies. Message & data rates may apply. Text HELP to (848) 800-4949 for assistance. You can reply STOP to unsubscribe at any time."
                        }
                      />
                      <Checkbox
                        label={
                          "By checking this box I agree to receive occasional marketing messages from BellaMi Academie."
                        }
                      />
                    </div>
                    <InternalLink to={"/terms-and-conditions/"}>
                      Terms of Service
                    </InternalLink>
                    <span>&nbsp;& &nbsp;</span>
                    <OutboundLink
                      to={
                        "https://fisherman-static.s3.amazonaws.com/public/__fisherman/Client+Website+Privacy+Policy.pdf"
                      }
                    >
                      Privacy Policy
                    </OutboundLink>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 23643 }) {
      title
      seoTitle
      description
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
    nfnjfmfpnjgkfnfplphpccldbinhgoninfnj: fishermanWebsiteComponent(
      fastId: { eq: "CustomForm" }
      componentIdentifier: { eq: "8d67df1e-653c-4b90-941e-40937c701fc5" }
    ) {
      data {
        header
        dynamicFormFields {
          name
          label
          style {
            color
            marginTop
            marginBottom
          }
          content
          options {
            label
            value
          }
          required
          inputType
          widgetType
          placeholder
          sendEmailToSelectedLocation
        }
        consentSettings {
          show
          required
        }
      }
    }
  }
`;
